// src/hooks/useAuth.js
import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";

export function useAuth() {
  // auth + user/org context
  const [session, setSession] = useState(null);
  const [me, setMe] = useState(null);
  const [authError, setAuthError] = useState(null);

  // ---------------- AUTH ----------------
  useEffect(() => {
    supabase.auth.getSession().then(({ data, error }) => {
      if (error) setAuthError(error.message);
      setSession(data.session ?? null);
    });
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => {
      setSession(s);
    });
    return () => sub.subscription.unsubscribe();
  }, []);

  useEffect(() => {
    const loadUserRow = async () => {
      setMe(null);
      if (!session?.user) return;
      const { id, email } = session.user;
      const { data, error } = await supabase
        .from("users")
        .select("id, org_id, role, full_name, email")
        .eq("id", id)
        .single();
      if (error) {
        setAuthError(
          "Logged in, but no user row found. Ask admin to create a public.users row for your auth user."
        );
        return;
      }
      setMe({ ...data, email: data.email || email });
    };
    loadUserRow();
  }, [session]);

  return { session, me, authError };
}
